module.exports = __webpack_public_path__ + "img/fejlec_kep_egyben_1360.fda79d5b.png";